import { render, staticRenderFns } from "./Tx.vue?vue&type=template&id=33d3e969&"
import script from "./Tx.vue?vue&type=script&lang=js&"
export * from "./Tx.vue?vue&type=script&lang=js&"
import style0 from "./Tx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports